/* Functional cabinet enquiry context only. Existing contact handling stays native. */
(function () {
  'use strict';
  function validHandle(value) { return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,127}$/.test(value); }
  function validId(value) { return /^[1-9][0-9]{0,19}$/.test(String(value || '')); }
  function consultationURL(base) {
    try {
      var url = new URL(base, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/consultation$/.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch (_) { return null; }
  }
  function enquiryURL(base, handle, id) {
    if (!validHandle(handle) || !validId(id)) return null;
    var url = consultationURL(base);
    if (!url) return null;
    url.searchParams.set('ig_product', handle);
    url.searchParams.set('ig_variant', String(id));
    url.hash = 'site-main';
    return url.href;
  }
  function validatedProduct(product, handle, id) {
    if (!validHandle(handle) || !validId(id) || !product || product.handle !== handle || (product.type !== '' && product.type !== 'Cabinet') || !/(?:^|-)(?:fusionplus|lux)(?:-cabinets)?-[0-9]+-ft(?:-|$)/.test(handle) || !Array.isArray(product.variants)) return null;
    var variant = product.variants.find(function (v) { return String(v.id) === String(id); });
    if (!variant || typeof product.title !== 'string' || typeof variant.title !== 'string') return null;
    return {product: product, variant: variant};
  }
  function applyContext(form, context, productRoot) {
    var product = context.product, variant = context.variant;
    var title = product.title.slice(0, 250), options = variant.title.slice(0, 250);
    var values = {
      product: title + ' - ' + new URL(productRoot + encodeURIComponent(product.handle) + '?variant=' + variant.id, window.location.origin).href,
      variant: options, id: String(variant.id), sku: String(variant.sku || '').slice(0, 120)
    };
    Object.keys(values).forEach(function (key) {
      var field = form.querySelector('[data-ig-enquiry-field="' + key + '"]');
      if (field) { field.value = values[key]; field.disabled = false; }
    });
    var container = form.querySelector('[data-ig-enquiry-context]');
    if (container) container.hidden = false;
    var summary = form.querySelector('[data-ig-enquiry-summary]');
    if (summary) { summary.textContent = title + ' — ' + options; summary.hidden = false; }
    form.dataset.igProductHandle = product.handle;
  }
  function installLink(link) {
    if (link.dataset.igEnquiryBound) return;
    link.dataset.igEnquiryBound = 'true';
    var form = link.closest('form');
    function sync() {
      var field = form && form.querySelector('[name="id"]');
      var id = field ? field.value : link.dataset.igVariantId;
      var href = enquiryURL(link.dataset.igConsultationUrl, link.dataset.igProductHandle, id);
      // Never silently send the initially rendered variant after selection becomes invalid.
      var fallback = consultationURL(link.dataset.igConsultationUrl);
      var destination = href || (fallback && fallback.href);
      if (destination && link.href !== destination) {
        var next = new URL(destination);
        // Existing consultation-click diagnostics classify relative storefront paths.
        link.href = next.pathname + next.search + next.hash;
      }
    }
    link.addEventListener('click', sync);
    if (form) form.addEventListener('change', function () { window.setTimeout(sync, 0); });
    document.addEventListener('variant-change', function () { window.setTimeout(sync, 0); }, true);
    sync();
  }
  function start() {
    if (window.__igCabinetEnquiryInstalled) return;
    window.__igCabinetEnquiryInstalled = true;
    document.querySelectorAll('[data-ig-cabinet-enquiry-link]').forEach(installLink);
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/consultation$/.test(window.location.pathname)) return;
    var forms = document.querySelectorAll('form[data-ig-lead-form="consultation"]');
    if (!forms.length) return;
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('ig_product'), id = params.get('ig_variant');
    if (!validHandle(handle) || !validId(id)) return;
    var root = window.location.pathname.replace(/pages\/consultation$/, 'products/');
    window.fetch(root + encodeURIComponent(handle) + '.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(function (response) { if (!response.ok) throw Error('Unavailable product'); return response.json(); })
      .then(function (product) {
        var context = validatedProduct(product, handle, id);
        if (context) forms.forEach(function (form) { applyContext(form, context, root); });
      }).catch(function () { /* Generic contact form remains usable when context is unavailable. */ });
  }
  if (window.__IG_CABINET_ENQUIRY_TEST__) window.__igCabinetEnquiryTest = {enquiryURL: enquiryURL, validatedProduct: validatedProduct, applyContext: applyContext, start: start, installLink: installLink};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
